import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import * as serviceWorker from "./serviceWorker";

// xAPI 실호출 검증 — 운영(real)만 제외하고 local/dev(검증)에서 로드한다.
if (String(process.env.REACT_APP_ENV).trim() !== "real") {
    import("./xapi/xapi-verify").catch(() => {});
}

window.addEventListener("popstate", function (e) {
    const prevURL = window.location.pathname + window.location.search;
    const nextURL = e.target.location.pathname + e.target.location.search;

    console.log(e);
    if (prevURL === nextURL) {
        console.log("!!");
    }
});

ReactDOM.render(<Root />, document.getElementById("root"));
serviceWorker.unregister();
